export const TRACKING_CATEGORY = "l1-mdd";
